import React, { Component } from "react";

class Resume extends Component {
  render() {
    if (this.props.data) {
      var skillmessage = this.props.data.skillmessage;
      var education = this.props.data.education.map(function (education) {
        return (
          <div key={education.school}>
            <h3>{education.school}</h3>
            <p className="info">
              {education.degree} <span>&bull;</span>
              <em className="date">{education.graduated}</em>
            </p>
            <p>{education.description}</p>
          </div>
        );
      });
      var work = this.props.data.work.map(function (work) {
        return (
          <div key={work.company}>
            <h3>{work.company}</h3>
            <p className="info">
              {work.title}
              <span>&bull;</span> <em className="date">{work.years}</em>
            </p>
            <p>{work.description}</p>
          </div>
        );
      });
      var skills = this.props.data.skills.map(function (skills) {
        var className = "bar-expand " + skills.name.toLowerCase();
        return (
          <li key={skills.name}>
            <span style={{ width: skills.level }} className={className}></span>
            <em>{skills.name}</em>
          </li>
        );
      });
    }

    return (
      <section id="resume">
        <div className="row education">
          <div className="three columns header-col">
            <h1>
              <span>Education</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">{education}</div>
            </div>
          </div>
        </div>

        <div className="row work">
          <div className="three columns header-col">
            <h1>
              <span>Work</span>
            </h1>
          </div>

          <div className="nine columns main-col">{work}</div>
        </div>

        <div className="row skill">
          <div className="three columns header-col">
            <h1>
              <span>Skills</span>
            </h1>
          </div>

          <div className="nine columns main-col">
            <p>{skillmessage}</p>

            {/* <div className="bars"> */}
            <div>
              <ul className="skills">
                {/* {skills} */}
                <ul id="front-end">
                  <li id="html5">
                    <i class="fab fa-html5 fa-3x"></i>HTML5
                  </li>
                  <li id="css3">
                    <i class="fab fa-css3-alt fa-3x"></i>CSS3
                  </li>
                  <li id="javascript">
                    <i class="fab fa-js-square fa-3x"></i>JavaScript
                  </li>
                  <li id="reactjs">
                    <i class="fab fa-react fa-3x"></i> ReactJS
                  </li>
                </ul>
                <ul id="front-end2">
                  <li id="typescript">TypeScript</li>
                  <li id="nextjs">Next.js</li>
                  <li id="tailwindcss">TailwindCSS</li>
                </ul>
                {/* <ul id="back-end">
                  <li id="python">
                    <i class="fab fa-python fa-3x"></i>Python
                  </li>
                  <li id="nodejs">
                    <i class="fab fa-node-js fa-3x"></i>NodeJS
                  </li>
                  <li id="express">ExpressJS</li>
                  <li id="csharp">C#</li>
                </ul> */}
                {/* <ul id="database">
                  <li id="sql">
                    <i class="fas fa-database fa fa-3x"></i>SQL
                  </li>
                  <li id="mongodb">
                    <i class="fab fa-envira fa-3x"></i>mongoDB
                  </li>
                </ul> */}
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;
